import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface AppNotification {
  id: string
  title: string
  body: string
  image?: string
  timestamp: string
  read: boolean
}

interface NotificationState {
  notifications: AppNotification[]
  unreadCount: number
  add: (n: { title: string; body?: string; image?: string }) => void
  markAllRead: () => void
  remove: (id: string) => void
  clear: () => void
}

// Keep only the most recent N foreground notifications in localStorage.
const MAX_NOTIFICATIONS = 30

export const useNotificationStore = create<NotificationState>()(
  persist(
    (set) => ({
      notifications: [],
      unreadCount: 0,
      add: (n) =>
        set((s) => {
          const item: AppNotification = {
            id: `${Date.now()}-${Math.floor(Math.random() * 1e6)}`,
            title: n.title,
            body: n.body ?? '',
            image: n.image,
            timestamp: new Date().toISOString(),
            read: false,
          }
          const notifications = [item, ...s.notifications].slice(0, MAX_NOTIFICATIONS)
          return { notifications, unreadCount: s.unreadCount + 1 }
        }),
      markAllRead: () =>
        set((s) => ({
          notifications: s.notifications.map((x) => (x.read ? x : { ...x, read: true })),
          unreadCount: 0,
        })),
      remove: (id) =>
        set((s) => {
          const target = s.notifications.find((x) => x.id === id)
          return {
            notifications: s.notifications.filter((x) => x.id !== id),
            unreadCount: target && !target.read ? Math.max(0, s.unreadCount - 1) : s.unreadCount,
          }
        }),
      clear: () => set({ notifications: [], unreadCount: 0 }),
    }),
    { name: 'drivys-notifications' }
  )
)
